import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
      fill="#687076"
    />
    <path
      d="M15.4706 14.5895L18.8656 12.6291C19.0455 12.5253 19.1567 12.3322 19.1567 12.1245V8.20417C19.1567 7.99691 19.045 7.80337 18.8656 7.69949L15.4706 5.7391C15.2908 5.63522 15.0678 5.63571 14.888 5.7391L11.493 7.69949C11.3131 7.80337 11.2019 7.99691 11.2019 8.20417V15.2103L8.82113 16.5847L6.44034 15.2103V12.4611L8.82113 11.0867L10.3915 11.9932V10.1489L9.11218 9.41049C9.02398 9.35953 8.92305 9.33258 8.82064 9.33258C8.71824 9.33258 8.6173 9.35953 8.52959 9.41049L5.13455 11.3709C4.95473 11.4748 4.84351 11.6678 4.84351 11.8756V15.7959C4.84351 16.0031 4.95522 16.1967 5.13455 16.3005L8.52959 18.2609C8.70893 18.3643 8.93235 18.3643 9.11218 18.2609L12.5072 16.301C12.687 16.1971 12.7983 16.0036 12.7983 15.7963V8.79018L12.8414 8.76568L15.1791 7.4158L17.5598 8.79018V11.5394L15.1791 12.9138L13.6111 12.0083V13.8526L14.888 14.59C15.0678 14.6934 15.2908 14.6934 15.4706 14.59V14.5895Z"
      fill="white"
    />
  </svg>
)
